export default {
  controls: [
    {
      title: 'controls.folding_of_siderails',
      icon: 'icon-postranice-sprint',
      animation: 'siderails',
      autoHideLabel: true,
      visible: true
    },
    {
      title: 'controls.push_handles',
      icon: 'icon-handles',
      animation: 'handles',
      autoHideLabel: true,
      visible: true
    },
    {
      title: 'controls.poles',
      icon: 'icon-poles',
      animation: 'poles',
      autoHideLabel: true,
      visible: true
    },
    {
      title: 'controls.idrive',
      icon: 'icon-idrive',
      animation: 'drive',
      autoHideLabel: true,
      visible: true
    },
  ],
  solutions: [
    {
      title: 'Easy patient transportation',
      style: 'video_thumbnails',
      image: 'solution--easy-patient-transportation.png',
      explanation: 'easy_patient_transportation'
    },
    {
      title: 'Simplify caregiver procedures',
      style: 'video_thumbnails',
      image: 'solution--simplify-caregiver-procedures.png',
      explanation: 'simplify_caregiver_procedures'
    },
    {
      title: 'Fall prevention',
      style: 'video_thumbnails',
      image: 'solution--fall-prevention.png',
      explanation: 'fall_prevention'
    },
    {
      title: 'Patient experience & recovery',
      style: 'video_thumbnails',
      image: 'solution--patient-recovery-improved-experience.png',
      explanation: 'support_patient_recovery_improved_experience',
    }
  ],
  keyFeatures: [
    {
      title: 'key_features.transportation',
      style: 'thumbnails',
      image: 'key_features--transportation.png',
      explanation: 'transportation',
    },
    {
      title: 'key_features.safety',
      style: 'thumbnails',
      image: 'key_features--safety.png',
      explanation: 'safety',
    },
    {
      title: 'key_features.additional_controls',
      style: 'thumbnails',
      image: 'key_features--foot_controls.png',
      explanation: 'additional_controls',
    },
    {
      title: 'key_features.positions',
      style: 'thumbnails',
      image: 'key_features--cardiac_chair.png',
      explanation: 'positions',
    },
    {
      title: 'key_features.mattress_options',
      style: 'thumbnails',
      image: 'key_features--mattress_options.png',
      explanation: 'mattress_options',
    },
    {
      title: 'key_features.accessories',
      style: 'thumbnails',
      image: 'key_features--accessories.png',
      explanation: 'accessories',
    },
  ],
  modifications: [
    {
      title: 'modifications.mattress',
      icon: 'icon-mattress',
      options: {
        style: 'thumbnails',
        default: 0,
        items: [
          {
            title: 'modifications.mattress.with_mattress',
            image: 'modifications--with_mattras.png',
            modelParts: [
              {
                name: 'matrace_geoPIV',
                visible: true
              }
            ]
          },
          {
            title: 'modifications.mattress.without_mattress',
            image: 'modifications--without_mattras.png',
            modelParts: [
              {
                name: 'matrace_geoPIV',
                visible: false
              }
            ]
          }
        ]
      }
    }
  ]
}